// conditionNode.js
import { Position } from 'reactflow';
import { BaseNode } from './BaseNode';

export const ConditionNode = ({ id, data }) => {
    return (
        <BaseNode
            id={id}
            data={data}
            title="Condition"
            handles={[
                { type: 'target', position: Position.Left, id: `${id}-input` },
                { type: 'source', position: Position.Right, id: `${id}-true`, style: { top: '30%' } },
                { type: 'source', position: Position.Right, id: `${id}-false`, style: { top: '70%' } }
            ]}
        >
            <div className="text-sm text-gray-500">
                <span>If / Else</span>
            </div>
        </BaseNode>
    );
};
